(function () {
  const topbar = document.querySelector('[data-ll-topbar-rotate]');
  if (!topbar) return;

  const b2b = topbar.querySelector('[data-ll-topbar-item="b2b"]');
  const igi = topbar.querySelector('[data-ll-topbar-item="igi"]');
  if (!b2b || !igi) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  let showB2b = true;
  setInterval(function () {
    showB2b = !showB2b;
    b2b.classList.toggle('is-active', showB2b);
    igi.classList.toggle('is-active', !showB2b);
  }, 3000);
})();
